<div [formGroup]="questionForm()!">
  @switch (this.answerType()) {
    @case (MeetingQuestionsAnswerTypeEnum.shortText) {
      <cf-form-field class="text-start">
        <cf-input-label weight="500" size="md" [required]="question()!.required">
          {{ question()!.question }}
        </cf-input-label>
        <input cf-input formControlName="answer_text" type="text" autocomplete="off" />
        <cf-input-error [error]="questionForm()!.controls.answer_text.errors">
          {{ "meeting.invitee-questions.answer" | translate }}
        </cf-input-error>
      </cf-form-field>
    }
    @case (MeetingQuestionsAnswerTypeEnum.longText) {
      <cf-form-field class="text-start">
        <cf-input-label weight="500" size="md" [required]="question()!.required">
          {{ question()!.question }}
        </cf-input-label>
        <textarea cf-input formControlName="answer_text" rows="2"></textarea>
        <cf-input-error [error]="questionForm()!.controls.answer_text.errors">
          {{ "meeting.invitee-questions.answer" | translate }}
        </cf-input-error>
      </cf-form-field>
    }
    @case (MeetingQuestionsAnswerTypeEnum.dropdown) {
      <div class="text-start">
        <cf-input-label [class.has-danger]="hasAnswerError" weight="500" size="md" [required]="question()!.required">
          {{ question()!.question }}
        </cf-input-label>
        <cf-select-new
          [provider]="answerOptions"
          [placeholder]="'select' | translate"
          formControlName="answer"
          (selectChange)="onOptionChange($event)"
          [optionFullView]="true"
          [appendTo]="''"
        ></cf-select-new>
        @if (hasAnswerError) {
          <cf-input-error [error]="questionForm()!.controls.answer.errors">
            {{ "meeting.invitee-questions.answer" | translate }}
          </cf-input-error>
        }
        @if (isOtherSelectedForAnswer) {
          <ng-container *ngTemplateOutlet="otherAnswer"></ng-container>
        }
      </div>
    }
    @case (MeetingQuestionsAnswerTypeEnum.checkboxes) {
      <div class="text-start">
        <cf-input-label [class.has-danger]="hasAnswersError" weight="500" size="md" [required]="question()!.required">
          {{ question()!.question }}
        </cf-input-label>
        <div class="d-flex flex-column">
          @for (answer of question()!.answers; track answer.id) {
            <cf-checkbox (change)="onCheckboxChange(answer, $event.checked)">
              {{ answer.answer }}
            </cf-checkbox>
          }
          @if (question()!.include_other_option) {
            <cf-checkbox (change)="onCheckboxChange({ id: OTHER_ANSWER_ID, answer: '' }, $event.checked)">
              {{ "other" | translate }}
            </cf-checkbox>
          }
          @if (isOtherSelectedForAnswers) {
            <ng-container *ngTemplateOutlet="otherAnswer"></ng-container>
          }
        </div>
      </div>
    }
    @case (MeetingQuestionsAnswerTypeEnum.radioButtons) {
      <div class="text-start">
        <cf-input-label [class.has-danger]="hasAnswerError" weight="500" size="md" [required]="question()!.required">
          {{ question()!.question }}
        </cf-input-label>
        <mat-radio-group
          class="d-flex flex-column"
          color="primary"
          formControlName="answer"
          (change)="onOptionChange($event.value)"
        >
          @for (answer of question()!.answers; track answer.id) {
            <mat-radio-button [value]="answer.id">
              {{ answer.answer }}
            </mat-radio-button>
          }
          @if (question()!.include_other_option) {
            <mat-radio-button [value]="OTHER_ANSWER_ID">
              {{ "other" | translate }}
            </mat-radio-button>
          }
        </mat-radio-group>
        @if (isOtherSelectedForAnswer) {
          <ng-container *ngTemplateOutlet="otherAnswer"></ng-container>
        }
      </div>
    }
    @case (MeetingQuestionsAnswerTypeEnum.phoneNumber) {
      <cf-form-phone-number
        [label]="question()!.question"
        [required]="question()!.required ?? false"
        formControlName="answer_text"
      ></cf-form-phone-number>
      <div class="text-start">
        @if (hasAnswerTextError) {
          <cf-input-error [error]="questionForm()!.controls.answer_text.errors">
            {{ "meeting.invitee-questions.answer" | translate }}
          </cf-input-error>
        }
      </div>
    }
  }

  <ng-template #otherAnswer>
    <div class="mt-1">
      <cf-form-field class="text-start">
        <input cf-input formControlName="answer_text" type="text" autocomplete="off" />
        <cf-input-error [error]="questionForm()!.controls.answer_text.errors">
          {{ "meeting.invitee-questions.answer" | translate }}
        </cf-input-error>
      </cf-form-field>
    </div>
  </ng-template>
</div>
